import React from 'react';
import '../styles/Features.css';

const Features = ({ onFeatureInteract }) => {
  const agentCategories = [
    {
      title: "Influencer Management",
      agents: ["Affiliate Finder", "Outreach Automator", "Commission Tracker"],
      icon: "💼"
    },
    {
      title: "Content Creation",
      agents: ["Blog Writer", "Video Script Generator", "Image Creator"],
      icon: "✍️"
    },
    {
      title: "Social Media",
      agents: ["Instagram Post Scheduler", "TikTok Trend Analyzer", "Engagement Booster"],
      icon: "📱"
    },
    {
      title: "Business Operations",
      agents: ["Customer Support AI", "Meeting Scheduler", "Email Automator"],
      icon: "🔄"
    }
  ];

  const scrollToAgentSelector = () => {
    document.getElementById('agent-selector').scrollIntoView({ behavior: 'smooth' });
    if (onFeatureInteract) {
      onFeatureInteract('explore_agents_clicked');
    }
  };

  return (
    <section className="features" id="features-section">
      <div className="container">
        <h2>Your Business Command Center: <span className="highlight">100+ AI Agents</span></h2>
        <p className="section-subtitle">
          One platform. Unlimited automation possibilities. Your entire business, powered by AI.
        </p>
        
        <div className="agent-count-banner">
          <div className="agent-metric">
            <h3>100+</h3>
            <p>AI Agents</p>
          </div>
          <div className="agent-metric">
            <h3>200+</h3>
            <p>Affiliates</p>
          </div>
          <div className="agent-metric">
            <h3>5+</h3>
            <p>Social Platforms</p>
          </div>
          <div className="agent-metric">
            <h3>0</h3>
            <p>Coding Needed</p>
          </div>
        </div>
        
        <div className="agent-categories">
          {agentCategories.map((category, index) => (
            <div className="category-card" key={index}>
              <div className="category-icon">{category.icon}</div>
              <h3>{category.title}</h3>
              <ul>
                {category.agents.map((agent, i) => (
                  <li key={i}>{agent}</li>
                ))}
              </ul>
              <p>+ more</p>
            </div>
          ))}
        </div>
        
        <div className="explore-agents">
          <button onClick={scrollToAgentSelector} className="secondary-button">
            Explore & Activate AI Agents
          </button>
        </div>
      </div>
    </section>
  );
};

export default Features;
